<template>
  <div class="modalback" @click="closeAction">
    <div class="modalcontent container" @click.stop="noAction">
      <div class="row justify-content-center" id="pdfcanvas">
        <template v-if="this.nowPage == 0">
          <div
            class="col-auto"
            style="
              width: 500px;
              height: 700px;
              background-color: white;
              position: relative;
            "
          >
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-auto mt-3" style="position: relative">
                  <p style="width: 440px; height: 30px; border: 3px solid black">
                    御見積書
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 text-start ps-4 mt-2">
                  <p class="small my-0">
                    〒{{ this.$store.state.estimatesData.zip01 }}-{{
                      this.$store.state.estimatesData.zip02
                    }}
                  </p>
                  <p class="small my-0">{{ this.$store.state.estimatesData.addr01 }}</p>
                  <p class="small my-0">{{ this.$store.state.estimatesData.addr02 }}</p>
                  <p class="small my-0">
                    {{
                      this.$store.state.estimatesData.company_name
                        ? this.$store.state.estimatesData.company_name
                        : ""
                    }}
                  </p>
                  <p class="small my-0">
                    {{
                      this.$store.state.estimatesData.department_name
                        ? this.$store.state.estimatesData.department_name
                        : ""
                    }}
                  </p>
                  <p class="small my-0">
                    {{ this.$store.state.estimatesData.name01 }}
                    {{ this.$store.state.estimatesData.name02 }} 様
                  </p>
                </div>
                <div class="col-6 text-start ps-5">
                  <img src="@/assets/acrypro/pdf_ambi.png" style="width: 100px" />
                  <p class="small my-0">〒550-0002</p>
                  <p class="small my-0">大阪市西区江戸堀2−1−1</p>
                  <p class="small my-0">江戸堀センタービル9F</p>
                  <p class="small my-0">06-6225-1239</p>
                </div>
              </div>
              <div class="row mt-1">
                <p class="ms-3 px-2 border-bottom border-dark">
                  総合計金額 {{ this.$store.state.estimatesProductData[0].totalPrice }}円
                </p>
                <table
                  class="table table-bordered table-sm table-striped"
                  style="line-height: 14px"
                >
                  <thead>
                    <tr>
                      <th><span class="smallfont">商品名</span></th>
                      <th><span class="smallfont">数量</span></th>
                      <th><span class="smallfont">単価</span></th>
                      <th><span class="smallfont">金額</span></th>
                    </tr>
                  </thead>
                  <template v-if="!this.$store.state.estimatesProductData">
                    <tbody>
                      <tr
                        v-for="(data, index) in this.detailDataArr[this.nowPage]"
                        v-bind:key="index"
                      >
                        <td class="text-start">
                          <span class="smallfont"
                            >{{ data.getProductTitle() }} / {{ data.productName }} / [
                            {{ data.categoryData.classcategory_name1 }} *
                            {{ data.categoryData.classcategory_name2 }} ]</span
                          >
                        </td>
                        <td class="text-end">
                          <span class="smallfont">{{ data.quantity }}</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont"
                            >{{ data.getOnePrice() + data.getOneMarginPrice() }}円</span
                          >
                        </td>
                        <td class="text-end">
                          <span class="smallfont"
                            >{{
                              (data.getOnePrice() + data.getOneMarginPrice()) * data.quantity
                            }}円</span
                          >
                        </td>
                      </tr>
                      <template v-if="this.page == 1">
                        <tr>
                          <td><span style="color: transparent">a</span></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">商品合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.productPrice }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">割引合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.discount }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end"><span class="smallfont">送料</span></td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.delivPrice }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">消費税</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.taxPrice }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">金額合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.totalPrice }}円</span
                            >
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                  <template v-if="this.$store.state.estimatesProductData">
                    <tbody>
                      <tr
                        v-for="(data, index) in this.detailDataArr[this.nowPage]"
                        v-bind:key="index"
                      >
                        <td class="text-start">
                          <span class="smallfont">{{ data.title }}</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont">{{ data.quantity }}</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont">{{ data.price }}円</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont"
                            >{{ data.price * data.quantity }}円</span
                          >
                        </td>
                      </tr>
                      <template v-if="this.page == 1">
                        <tr>
                          <td><span style="color: transparent">a</span></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">商品合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].productPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">割引合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesProductData[0].discount }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end"><span class="smallfont">送料</span></td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].delivPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">消費税</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].taxPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">金額合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].totalPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                </table>
              </div>
              <template v-if="this.page == 1">
                <div class="mx-2 row border-top border-dark">
                  <p class="small d-block">＜備考＞</p>
                </div>
                <div class="row mx-2 text-start">
                  <p class="small">
                    発行日:{{ this.$store.state.estimatesData.issueDate }}
                  </p>
                  <p class="small">
                    見積書の有効期限は発効日より1ヶ月です。
                    販売停止及び在庫切れの商品は本見積書に記載がされていても注文いただけない場合があります。
                  </p>
                </div>
              </template>
            </div>
            <p class="small" style="position: absolute; left: 240px; top: 670px">
              {{ this.nowPage + 1 }} / {{ this.page }}
            </p>
          </div>
        </template>
        <template v-if="this.nowPage > 0">
          <div
            class="col-auto"
            style="
              width: 500px;
              height: 700px;
              background-color: white;
              position: relative;
            "
          >
            <div class="container">
              <div class="row mt-5">
                <table
                  class="table table-bordered table-sm table-striped"
                  style="line-height: 14px"
                >
                  <thead>
                    <tr>
                      <th><span class="smallfont">商品名/商品コード/[規格]</span></th>
                      <th><span class="smallfont">数量</span></th>
                      <th><span class="smallfont">単価</span></th>
                      <th><span class="smallfont">金額</span></th>
                    </tr>
                  </thead>
                  <template v-if="!this.$store.state.estimatesProductData">
                    <tbody>
                      <tr
                        v-for="(data, index) in this.detailDataArr[this.nowPage]"
                        v-bind:key="index"
                      >
                        <td class="text-start">
                          <span class="smallfont"
                            >{{ data.getProductTitle() }} / {{ data.productName }} / [
                            {{ data.categoryData.classcategory_name1 }} *
                            {{ data.categoryData.classcategory_name2 }} ]</span
                          >
                        </td>
                        <td class="text-end">
                          <span class="smallfont">{{ data.quantity }}</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont"
                            >{{ data.getPrice() + data.getMarginPrice() }}円</span
                          >
                        </td>
                        <td class="text-end">
                          <span class="smallfont"
                            >{{
                              (data.getPrice() + data.getMarginPrice()) * data.quantity
                            }}円</span
                          >
                        </td>
                      </tr>
                      <template v-if="this.nowPage == this.page - 1">
                        <tr>
                          <td><span style="color: transparent">a</span></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">商品合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.productPrice }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">割引合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.discount }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end"><span class="smallfont">送料</span></td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.delivPrice }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">消費税</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.taxPrice }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">金額合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesData.totalPrice }}円</span
                            >
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                  <template v-if="this.$store.state.estimatesProductData">
                    <tbody>
                      <tr
                        v-for="(data, index) in this.detailDataArr[this.nowPage]"
                        v-bind:key="index"
                      >
                        <td class="text-start">
                          <span class="smallfont">{{ data.title }}</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont">{{ data.quantity }}</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont">{{ data.price }}円</span>
                        </td>
                        <td class="text-end">
                          <span class="smallfont"
                            >{{ data.price * data.quantity }}円</span
                          >
                        </td>
                      </tr>
                      <template v-if="this.nowPage == this.page - 1">
                        <tr>
                          <td><span style="color: transparent">a</span></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">商品合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].productPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">割引合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{ this.$store.state.estimatesProductData[0].discount }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end"><span class="smallfont">送料</span></td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].delivPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">消費税</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].taxPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td class="text-end">
                            <span class="smallfont">金額合計</span>
                          </td>
                          <td class="text-end">
                            <span class="smallfont"
                              >{{
                                this.$store.state.estimatesProductData[0].totalPrice
                              }}円</span
                            >
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </template>
                </table>
              </div>
              <template v-if="this.nowPage == this.page - 1">
                <div class="mx-2 row border-top border-dark">
                  <p class="small d-block">＜備考＞</p>
                </div>
                <div class="row mx-2 text-start">
                  <p class="small">
                    発行日:{{ this.$store.state.estimatesData.issueDate }}
                  </p>
                  <p class="small">
                    見積書の有効期限は発効日より1ヶ月です。
                    販売停止及び在庫切れの商品は本見積書に記載がされていても注文いただけない場合があります。
                  </p>
                </div>
              </template>
            </div>
            <p class="small" style="position: absolute; left: 240px; top: 670px">
              {{ this.nowPage + 1 }} / {{ this.page }}
            </p>
          </div>
        </template>
      </div>
      <div class="row justify-content-center mt-4">
        <div class="col">
          <button class="btn btn-light" @click="pageAction(false)">前のページ</button>
        </div>
        <div class="col-auto">
          <button class="btn btn-dark" @click="downloadEstimates">ダウンロード</button>
        </div>
        <div class="col">
          <button class="btn btn-light" @click="pageAction(true)">次のページ</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import * as JsPDF from 'jspdf';
import html2canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  name: "Estimates_Ap",
  props: {},
  data: function () {
    return {
      nowPage: 0,
      page: 1,
      detailDataArr: [], // 配列の配列
      isPdfProcess: false,
      pdfPage: 0,
      dataUris: [],
      onePageMaxCnt:9,
      maxcnt:30,
    };
  },
  created() {
    // ページの計算
    let len = 0;
    if (this.$store.state.estimatesProductData) {
      len = this.$store.state.estimatesProductData.length;
    } else {
      len = this.$store.state.products.length;
    }
    let cnt = len - this.onePageMaxCnt;
    if (cnt <= 0) {
      this.page = 1;
      if (this.$store.state.estimatesProductData) {
        this.detailDataArr.push(this.$store.state.estimatesProductData);
      } else {
        this.detailDataArr.push(this.$store.state.products);
      }
    } else {
      if(cnt > 10){
        if (this.$store.state.estimatesProductData) {
        this.detailDataArr.push(this.$store.state.estimatesProductData.slice(0, this.onePageMaxCnt - 1 + 10));
      } else {
        this.detailDataArr.push(this.$store.state.products.slice(0, this.onePageMaxCnt - 1 + 10));
      } 
      } else {
        if (this.$store.state.estimatesProductData) {
        this.detailDataArr.push(this.$store.state.estimatesProductData.slice(0, this.onePageMaxCnt - 1));
      } else {
        this.detailDataArr.push(this.$store.state.products.slice(0, this.onePageMaxCnt - 1));
      }
      }
    } 
    let bi = this.onePageMaxCnt;
    while (cnt >= 0) {
      cnt -= this.maxcnt;
      this.page += 1;
      if (cnt < 0) {
        if (this.$store.state.estimatesProductData) {
          this.detailDataArr.push(this.$store.state.estimatesProductData.slice(bi));
        } else {
          this.detailDataArr.push(this.$store.state.products.slice(bi));
        }
        if (cnt + this.maxcnt > 20) {
          this.page += 1;
          this.detailDataArr.push([]);
        }
      } else {
        if (this.$store.state.estimatesProductData) {
          this.detailDataArr.push(
            this.$store.state.estimatesProductData.slice(bi, bi + this.maxcnt)
          );
        } else {
          this.detailDataArr.push(this.$store.state.products.slice(bi, bi + this.maxcnt));
        }
        bi += this.maxcnt;
      }
    }
  },
  mounted: function () {
    console.log(this.$store.state.estimatesProductData);
  },
  methods: {
    pageAction(flag) {
      if (flag) {
        this.nowPage += 1;
        if (this.nowPage >= this.detailDataArr.length) {
          this.nowPage = this.detailDataArr.length - 1;
        }
      } else {
        this.nowPage -= 1;
        if (this.nowPage < 0) {
          this.nowPage = 0;
        }
      }
    },
    getCanvasUrl(page) {
      return new Promise((resolve) => {
        this.nowPage = page;
        this.$nextTick(() => {
          html2canvas(document.getElementById("pdfcanvas"), {
            scale: 3,
          })
            .then((canvas) => {
              // html2canvasで取得した要素をPDFに追加する処理
              resolve(canvas.toDataURL());
            })
            .catch((e) => {
              console.log(e);
            });
        });
       });
    },
    async startPdfDownload() {
      this.dataUris = []
      for (let page = 0; page < this.page; page++) {
        this.dataUris.push(await this.getCanvasUrl(page));
      }
      const pdf = new JsPDF("p", "pt", "a4");
      const width = pdf.internal.pageSize.width;
      for (let uri of this.dataUris) {
        // html2canvasで取得した要素をPDFに追加する処理
        const dataURI = uri;
        pdf.addImage(dataURI, "JPEG", (- width * 0.2) / 2, 0, width * 1.2, 0);
        if(uri != this.dataUris.slice(-1)[0]){
          pdf.addPage()
        }
      }
      pdf.save(
        "" +
          this.$common.getStringFromDate(new Date()) +
          ".pdf"
      );
    },

    closeAction() {
      this.$store.commit("hideEstimates");
    },
    noAction() {},
    async downloadEstimates() {
      this.$store.commit("showLoading")
      let page = this.nowPage
      await this.startPdfDownload();
      this.nowPage = page
      this.$store.commit("hideLoading")
    },
  },
  components: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalback {
  z-index: 130;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  z-index: 131;
  width: 600px;
  height: 800px;
  padding: 1em;
  background-color: rgb(85, 82, 82);
  border: 3px solid rgb(215, 215, 215);
  user-select: text !important;
}
.smallfont {
  font-size: 9px;
}
tr {
  line-height: 7px;
  min-height: 7px;
  height: 7px;
}
</style>
